import { Routes } from '@angular/router';
import { CanDeactivateGuard } from '../app/guards/can-deactivate.guard';
import { CanActivateGuard } from '../app/guards/can-activate.guards';

const config = (<any>window).ftClientConfig;

function getAuthRoute(config): Routes {
  if (config.authentication?.disableLocalLogin === true) {
    return [];
  }

  return [{
    path: 'auth',
    loadChildren: () => import('../app/modules/auth/auth.module').then(m => m.AuthModule)
  }];
}

const authRoutes: Routes = [];
// push after initialization so the initializer is an ArrayLiteralExpression
authRoutes.push(...getAuthRoute(config));

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/default',
    pathMatch: 'full'
  },
  {
    path: 'default',
    loadComponent: () => import('../app/components/default/default.component').then(m => m.DefaultComponent),
    canActivate: [CanActivateGuard]
  },
  ...authRoutes,
  {
    path: 'search',
    loadChildren: () => import('../app/modules/search/search.module').then(m => m.SearchModule)
  },
  {
    path: 'form',
    loadComponent: () => import('../app/components/top-bar/top-bar.component').then(m => m.TopBarComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('../app/components/default/default.component').then(m => m.DefaultComponent),
        pathMatch: 'full'
      },
      {
        path: ':id',
        loadComponent: () => import('../app/components/template/template-view.component').then(m => m.TemplateViewComponent),
        canDeactivate: [CanDeactivateGuard],
        canActivate: [CanActivateGuard]
      },
      {
        path: ':id/:templateId',
        loadComponent: () => import('../app/components/template/template-view.component').then(m => m.TemplateViewComponent),
        canDeactivate: [CanDeactivateGuard],
        canActivate: [CanActivateGuard]
      }
    ]
  },
  {
    path: 'formNoNavBar/:id',
    loadComponent: () => import('../app/components/template/template-view.component').then(m => m.TemplateViewComponent),
    data: { noNavBar: true },
    canDeactivate: [CanDeactivateGuard],
    canActivate: [CanActivateGuard]
  },
  {
    path: 'map/:id',
    loadComponent: () => import('../app/components/template/template-view.component').then(m => m.TemplateViewComponent),
    data: { noNavBar: true },
    canDeactivate: [CanDeactivateGuard],
    canActivate: [CanActivateGuard]
  },
  {
    path: 'notFound',
    loadComponent: () => import('../app/components/not-found/not-found.component').then(m => m.NotFoundComponent)
  },
  {
    path: ':accountPublicURL',
    loadComponent: () => import('../app/components/public-login/public-login.component').then(m => m.PublicLoginComponent)
  },
  {
    path: ':accountPublicURL/:paramRoute/:paramQuery',
    loadComponent: () => import('../app/components/public-login/public-login.component').then(m => m.PublicLoginComponent)
  },
  {
    path: ':accountPublicURL/:paramRoute',
    loadComponent: () => import('../app/components/public-login/public-login.component').then(m => m.PublicLoginComponent)
  },
  {
    path: ':accountPublicURL/:paramRoute/:paramQuery/:override',
    loadComponent: () => import('../app/components/public-login/public-login.component').then(m => m.PublicLoginComponent)
  }
];
